module.exports = __webpack_public_path__ + "static/img/01.e5b520f4.jpg";